import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../utils/tpoGenQueryKeys';
import type { ComparisonReportDetailResponse } from '../../types';

const fetchComparisonReportDetail = async (
    reportId: string,
    signal?: AbortSignal,
): Promise<ComparisonReportDetailResponse> => {
    let token = '';
    try { token = localStorage.getItem('accessToken') ?? ''; } catch {}
    const response = await axios(tpoGenUrls.getComparisonReportDetail(reportId), {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
        signal,
    });
    return response.data;
};

interface UseComparisonReportDetailResult {
    reportDetail: ComparisonReportDetailResponse | null;
    isPending: boolean;
    isFetching: boolean;
    isError: boolean;
}

const useComparisonReportDetail = (reportId: string | null): UseComparisonReportDetailResult => {
    const enabled = !!reportId;

    const { data, isPending, isFetching, isError } = useQuery({
        queryKey: tpoGenKeys.comparisonReportDetail(reportId ?? ''),
        queryFn: ({ signal }) => fetchComparisonReportDetail(reportId as string, signal),
        enabled,
    });

    return {
        reportDetail: data ?? null,
        isPending: enabled && isPending,
        isFetching,
        isError,
    };
};

export default useComparisonReportDetail;
